import { MTR_PICKER_BASE_FILTERS } from '#/modules/imsMgmt/settings/mtr/hooks/useMtrPickerListQuery';

/** 對齊 MtrPicker（ACTIVE + NORMAL）。 */
export function isMtrRowPurchasableInPicker(row) {
  if (!row?.id) {
    return false;
  }

  return row.status === MTR_PICKER_BASE_FILTERS.status
    && row.mtrKind === MTR_PICKER_BASE_FILTERS.mtrKind;
}

export function getMtrPurchasableRejectReason(row) {
  if (!row?.id) {
    return '找不到物料';
  }
  if (row.status !== MTR_PICKER_BASE_FILTERS.status) {
    return '物料非啟用狀態';
  }
  if (row.mtrKind !== MTR_PICKER_BASE_FILTERS.mtrKind) {
    return '僅一般物料可採購';
  }
  return '無法加入採購明細';
}
